import produce from "immer";
import { NOTIFICATION_ADD, NOTIFICATION_DELETE } from "../actions/types";

const notifyInitState = {
  ids: [],
  hash: {},
};

export const notifications = (state = notifyInitState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case NOTIFICATION_ADD:
        const notification = action.notification;
        draft.ids.push(notification.id);
        draft.hash[notification.id] = notification;
        break;
      case NOTIFICATION_DELETE:
        delete draft.hash[action.notificationId];
        draft.ids = draft.ids.filter((id) => id !== action.notificationId);
        break;
      default:
    }
  });
